import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
export default {
  components: {
    XytAdv: function XytAdv() {
      return import('@tencent/xyt-adv');
    }
  },
  data: function data() {
    return {
      isShowQmAdv: false
    };
  },
  computed: {
    // 是否 vip
    isVip: function isVip() {
      var welfare = this.$store.state.indexPageModule.welfare;
      return welfare.iVipStatus === 3;
    },
    vipLevel: function vipLevel() {
      var welfare = this.$store.state.indexPageModule.welfare;
      return welfare.iVipLevel;
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this = this;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!window.pageIsOnload) {
                window.addEventListener('load', function () {
                  setTimeout(function () {
                    _this.isShowQmAdv = true;
                  }, 500);
                });
              } else {
                setTimeout(function () {
                  _this.isShowQmAdv = true;
                }, 500);
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }()
};